import React from 'react';
import { Button, Col, DatePicker, Dropdown, Menu, Row } from 'antd';
import {
  DownloadOutlined,
  FileTextOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { REPORT_TYPE } from '../../../constants';

const { RangePicker } = DatePicker;

const ReportHeader = ({
  dateRanger,
  changeDateRanger,
  handleDateRangerChange,
  handleDownloadReportAccountCamera,
  handleExportPdf,
  isLoadingExportAccountCamera,
  isLoadingExportStorageCamera,
  isLoadingExportGatewayCamera,
  isLoadingExportGatewayCameraInfo,
}) => {
  return (
    <Row style={{ marginBottom: 10, padding: '0px 20px' }}>
      <Col span={12} className="input_date_picker">
        <Button onClick={() => changeDateRanger(7)}>The last 7 days</Button>
        <Button onClick={() => changeDateRanger(30)}>The last month</Button>
        <RangePicker
          defaultValue={[
            moment()
              .subtract({ month: 1 })
              .set({ hour: 0, minute: 0, second: 0 }),
            moment().set({ hour: 23, minute: 59, second: 59 }),
          ]}
          value={
            dateRanger && dateRanger.length === 2
              ? [moment(dateRanger[0]), moment(dateRanger[1])]
              : []
          }
          onChange={handleDateRangerChange}
        />
      </Col>
      <Col span={12}>
        <Row justify="end" gutter={[8, 8]}>
          <Col>
            <div className="edit-button" title="Report">
              <Dropdown
                trigger={['click']}
                placement="bottomRight"
                overlay={
                  <Menu>
                    <Menu.Item
                      key="0"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_ACCOUNT,
                        )
                      }
                      disabled={isLoadingExportAccountCamera}
                    >
                      {isLoadingExportAccountCamera ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>Report account camera</span>
                    </Menu.Item>
                    <Menu.Item
                      key="1"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_STORAGE,
                        )
                      }
                      disabled={isLoadingExportStorageCamera}
                    >
                      {isLoadingExportStorageCamera ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>Report storage camera</span>
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_GATEWAY,
                        )
                      }
                      disabled={isLoadingExportGatewayCamera}
                    >
                      {isLoadingExportGatewayCamera ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>Report camera/gateway information</span>
                    </Menu.Item>
                    <Menu.Item
                      key="3"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_GATEWAY_INFO,
                        )
                      }
                      disabled={isLoadingExportGatewayCameraInfo}
                    >
                      {isLoadingExportGatewayCameraInfo ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>Report gateway information</span>
                    </Menu.Item>
                  </Menu>
                }
              >
                <Button icon={<FileTextOutlined />}>Report</Button>
              </Dropdown>
            </div>
          </Col>

          <Col className="export-button">
            <Button onClick={handleExportPdf}>Export</Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ReportHeader;
